export interface IBackupRequestLookups {
  disputeTypes: IBackupRequestType[];
  contacts?: IBackupRequestContact[];
  noteTemplate?: string;
}

export interface IBackupRequestContact {
  name: string;
  email: string;
}

export interface IBackupRequestType {
  disputeTypeId: number;
  disputeTypeName: string;
  disputeTypeKey: string;
  isCustomerDeduction?: boolean | null;
  children?: IBackupRequestTypeChild[] | null;
}

export interface IBackupRequestTypeChild {
  disputeTypeId: number;
  disputeTypeName: string;
  disputeTypeKey: string;
  isCustomerDeduction?: boolean | null;
}

export class BackupRequestLookups implements IBackupRequestLookups {
  private readonly _disputeTypes: IBackupRequestType[];
  private readonly _contacts?: IBackupRequestContact[];
  private readonly _noteTemplate?: string;
  constructor(props: IBackupRequestLookups) {
    this._disputeTypes = props.disputeTypes.map(type => new BackupRequestType(type));
    this._contacts = props.contacts?.map(contact => new BackupRequestContact(contact)) ?? [];
    this._noteTemplate = props.noteTemplate;
  }

  public get disputeTypes(): IBackupRequestType[] {
    return this._disputeTypes;
  }
  public get contacts(): IBackupRequestContact[] | undefined {
    return this._contacts;
  }
  public get noteTemplate(): string | undefined {
    return this._noteTemplate;
  }
}

export class BackupRequestType implements IBackupRequestType {
  private readonly _disputeTypeId: number;
  private readonly _disputeTypeName: string;
  private readonly _disputeTypeKey: string;
  private readonly _isCustomerDeduction?: boolean | null;
  private readonly _children?: IBackupRequestTypeChild[] | null;
  constructor(props: IBackupRequestType) {
    this._disputeTypeId = props.disputeTypeId;
    this._disputeTypeName = props.disputeTypeName;
    this._disputeTypeKey = props.disputeTypeKey;
    this._isCustomerDeduction = props.isCustomerDeduction;
    this._children = props.children;
  }

  public get disputeTypeId(): number {
    return this._disputeTypeId;
  }
  public get disputeTypeName(): string {
    return this._disputeTypeName;
  }
  public get disputeTypeKey(): string {
    return this._disputeTypeKey;
  }
  public get isCustomerDeduction(): boolean | null {
    return this._isCustomerDeduction ?? null;
  }
  public get children(): IBackupRequestTypeChild[] | null {
    return this._children ?? null;
  }
}

export class BackupRequestContact implements IBackupRequestContact {
  private readonly _name: string;
  private readonly _email: string;
  constructor(props: IBackupRequestContact) {
    this._name = props.name;
    this._email = props.email;
  }

  public get name(): string {
    return this._name;
  }
  public get email(): string {
    return this._email;
  }
}
